import api from '@/api/Api'
import LoginModel from '@/model/LoginModel'
import CordovaModel from '@/model/CordovaModel'
import store from '@/store'
import logger from '@/assets/log'
const log = logger("store:department");

// initial state
const state = {
    currentId: 0, //已选部门
    currentName: '',
    depLevel: null
}

// getters
const getters = {
}
// actions
const actions = {
};

// mutations
const mutations = {
    current(state, {id, name}) {
        state.currentId = id;
        state.currentName = name;
        // state.depLevel = depLevel;
        store.commit("views/currentDepId", id);
    },
    currentDepLevel(state, {depLevel}) {
        state.depLevel = depLevel;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}